import "./LoadingMessageBox.css";
const LoadingMessageBox = () => {
  return (
    <div className={"loading-message-box__root"}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default LoadingMessageBox;
